import { render, staticRenderFns } from "./greed_tome_modal.vue?vue&type=template&id=2ebd740b&scoped=true"
import script from "./greed_tome_modal.vue?vue&type=script&lang=ts"
export * from "./greed_tome_modal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ebd740b",
  null
  
)

export default component.exports